export const loadWishlistAction = (wishlists) => {
    return {
        type: "LOAD_WISHLIST",
        payload: wishlists,
    };
};

export const wishlistAction = (wishlist) => {
    return {
        type: "UPDATE_WISHLIST",
        payload: wishlist,
    };
};

export const loginSuccess = (username, phone, email, role = "", is_admin, token) => {
    return {
        type: "LOGIN_SUCCESS",
        payload: {
            user: username,
            phoneNumber: phone,
            email: email,
            role: role,
            is_admin: is_admin,
            loginToken: token,
            isLogged: true,
        },
    };
};

export const updateData = (username, phone, email, role = "") => {
    return {
        type: "UPDATE_DATA",
        payload: {
            user: username,
            phoneNumber: phone,
            email: email,
            role: role,
            isLogged: true,
        },
    };
};

export const logoutSuccess = () => {
    return {
        type: "LOGOUT_SUCCESS",
        payload: {
            email: null,
            isLogged: false,
        },
    };
};

export const getUserData = (payload) => {
    return {
        type: "ADD_PROFILE",
        payload: payload,
    };
};

export const UnitAction = (payload) => {
    return {
        type: "UPDATE_UNIT",
        payload: payload,
    };
};

export const ViewAction = (payload) => {
    return {
        type: "UPDATE_VIEW",
        payload: payload,
    };
};

export const FavAction = (payload) => {
    return {
        type: "UPDATE_FAV",
        payload: payload,
    };
};

export const NameAction = (payload) => {
    return {
        type: "UPDATE_NAME",
        payload: payload,
    };
};
